import DatesExpiredContainer from './DatesExpiredContainer';

export default DatesExpiredContainer;
